import { inject, Injectable } from "@angular/core";
import { forkJoin, Observable, retry, tap } from "rxjs";
import { User } from "src/app-legacy/core/models/user";
import { AppService } from "src/app-legacy/core/services/app.service";
import { CurrentSchoolService } from "./current-school.service";
import { CurrentUserService } from "./current-user.service";
import { School } from "src/app-legacy/core/models/school";

interface CurrentState {
	user: User;
	school: School;
}

@Injectable({
	providedIn: "root",
})
export class CurrentStateService {
	private appService = inject(AppService);
	private currentSchoolService = inject(CurrentSchoolService);
	private currentUserService = inject(CurrentUserService);

	getCurrentState(): Observable<CurrentState> {
		return forkJoin({
			user: this.currentUserService.getCurrentUser(),
			school: this.currentSchoolService.getCurrentSchool(),
		}).pipe(
			// One retry absorbs a transient failure on either call. forkJoin fails if EITHER errors, so
			// a single blip on one of two parallel requests was enough to block the whole route.
			retry({ count: 1, delay: 400 }),
			tap((state) => {
				this.appService.currentUser = { user: state.user, permissions: state.user.permissions };
				this.appService.currentSchool = state.school;
			}),
		);
	}
}
